export default "__VITE_ASSET__BzgY1VTI__"